import React, { Fragment, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import BreadCrumb from '../../components/common/BreadCrumb';
import { GlobalContext } from '../../context/Provider';
import ProductForm from './ProductForm';
import { AlertTriangle, PlusCircle } from 'lucide-react';

const EditProduct: React.FC = () => {
  const { language_data, authState } = useContext(GlobalContext);
  const { id } = useParams<{ id: string }>();

  const breadCrumbPath = [
    {
      name: `${language_data?.[authState.lang]?.common_home || 'Home'}`,
      url: `/`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_product || 'Product'} ${
        language_data?.[authState.lang]?.common_list || 'List'
      }`,
      url: `/products/1`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_product || 'Product'} ${
        language_data?.[authState.lang]?.common_deatil || 'Detail'
      }`,
      url: `/product/${id}`,
      active: '',
    },
    {
      name: `${language_data?.[authState.lang]?.common_edit || 'Edit'} ${
        language_data?.[authState.lang]?.common_product || 'Product'
      }`,
      url: ``,
      active: 'not-allowed',
    },
  ];

  return (
    <Fragment>
      <BreadCrumb pathNameDeclare={breadCrumbPath} />
      {!authState?.is_bank_added ? (
        <div className="p-4 sm:p-6 lg:p-8 bg-slate-50/50 min-h-[70vh] flex items-center justify-center">
          <div className="max-w-md w-full bg-white rounded-2xl border border-slate-100 shadow-sm p-8 text-center space-y-4">
            <div className="w-16 h-16 rounded-2xl bg-amber-50 text-amber-500 border border-amber-200/60 flex items-center justify-center mx-auto shadow-2xs">
              <AlertTriangle className="w-8 h-8" />
            </div>
            <h3 className="text-xl font-bold text-slate-900 tracking-tight m-0">
              Bank Details Required
            </h3>
            <p className="text-xs sm:text-sm text-slate-500 font-medium leading-relaxed m-0">
              You need to configure your verified bank account before you can edit catalog products.
            </p>
            <div className="pt-2">
              <Link
                to="/profile/bank-details"
                className="inline-flex items-center justify-center gap-2 w-full py-3 px-5 rounded-xl bg-[#1AA7DE] hover:bg-[#158ebf] text-white font-bold text-sm shadow-sm transition-all active:scale-[0.98]"
              >
                <PlusCircle className="w-4 h-4" />
                <span>Add Bank Details Now</span>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <ProductForm mode="edit" productId={id} />
      )}
    </Fragment>
  );
};

export default EditProduct;